import { render } from "./common-dummy-component.vue?vue&type=template&id=7b36130e&ts=true"
import script from "./common-dummy-component.vue?vue&type=script&lang=ts"
export * from "./common-dummy-component.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__